import { configureStore, Action } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import authReducer from "redux/auth/authSlice";

const store = configureStore({
	reducer: {
		auth: authReducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;

// Add this line to define a custom dispatch type that understands thunks
export type AppDispatch = typeof store.dispatch;

export default store;
